module.exports = __webpack_public_path__ + "static/media/Group.05d2c538.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Group.png
// module id = 55
// module chunks = 0